
export default {
  newsletter: {
    marginTop: 20
  },
  newsletterIFrame: {
    width: '100%',
    height: 'calc(100vh - 170px)'
  },
  formLabel: {
    padding: 10
  },
  textarea: {
    height: 'calc(100vh - 340px)',
  },
  textareaGenerate: {
    height: 'calc(100vh - 430px)',
    background: 'rgb(245,245,245)'
  },
  generateButton: {
    float: 'right',
    marginTop: 10,
    marginBottom: 10,
    display: 'block'
  },
  header: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginTop: 15
  },
  emailBadge: {
    margin: '10px 80px 0 0',
    float: 'left'
  },
  emailSentLabel: {
    marginLeft: 320,
    marginTop: -70,
    position: 'absolute',
    textDecoration: 'underline',
    background: '#fff',
    padding: '10px 15px',
    borderRadius: 10
  },
  publishLabel: {
    position: 'absolute',
    top: 5,
    left: 5,
    background: '#ddd',
    padding: '2px 5px',
    borderRadius: 5,
    color: '#fff'
  },
  dbselectorColumn: {
    border: '1px solid #eee',
    padding: 10
  }
}




// WEBPACK FOOTER //
// ./src/newsletter/newsletter.css.js